export const latinise = (str: string): string =>
  str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : ''
